// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDfy_ytJJBQVM-Ahg-mDDD0xRR3unl0zQo",
    authDomain: "questworlds-ec426.firebaseapp.com",
    databaseURL: "https://questworlds-ec426.firebaseio.com",
    projectId: "questworlds-ec426",
    storageBucket: "questworlds-ec426.appspot.com",
    messagingSenderId: "98113166119",
    appId: "1:98113166119:web:9ce596b8484acc6c60a702",
    measurementId: "G-YZG199QRJH"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
